module.exports = __webpack_public_path__ + "fonts/DotOutline.0c86dfc1.ttf";